// <script src="//shopfy-features.myshopify.com/cdn/shop/t/2/assets/b_somnia.js" defer="defer"></script>
console.log('feature')